/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Email_UsInputs */

const en_mobile_email_us = /** @type {(inputs: Mobile_Email_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email us`)
};

const es_mobile_email_us = /** @type {(inputs: Mobile_Email_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envíanos un correo`)
};

/**
* | output |
* | --- |
* | "Email us" |
*
* @param {Mobile_Email_UsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_email_us = /** @type {((inputs?: Mobile_Email_UsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Email_UsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_email_us(inputs)
	return en_mobile_email_us(inputs)
});